export const REPLACE = 'REPLACE';
export const RESCIND = 'RESCIND';